import Client from './Client'
import { Error } from './Error'

export default class Reports extends Client {

  async fetchReports(token, payload) {
    try {
      const query =  {
        find: payload.search,
        state: payload.state,
        created_at: payload.range,
        offset: payload.offset,
        template_id: payload.template,
        limit: payload.limit
      }
      return await this.request(token, 'get', 'report', null, query)
    } catch (error) {
      throw new Error(error)
    }
  }

  async saveReportFromTemplate(token, templateID, fields ) {
    try {
      return await this.request(token, 'post', `report/init/${templateID}`, { fields }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async deleteReport(token, payload) {
    try {
      return await this.request(token, 'delete', `report/${payload}`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchReport(token, payload) {
    try {
      return await this.request(token, 'get', `report/${payload}`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async downloadPdf(token, payload) {
    try {
      return await this.request(token, 'get', `report/${payload.proovCode}/pdf`, null, { state: payload.state })
    } catch (error) {
      throw new Error(error)
    }
  }

  async exportReports(token, proovCodes, download, format) {
    try {
      const params = {
        proov_code: proovCodes,
        email: !download || false,
        url: download
      }
      return await this.request(token, 'post', 'report/export', params, { file_type: format })
    } catch (error) {
      throw new Error(error)
    }
  }

  async exportReportsWithParams(token, filters, download, format, proovCodes = null) {
    try {
      const query =  {
        find: filters.search,
        state: filters.state,
        created_at: filters.range,
        offset: null,
        template_id: filters.template,
        limit: null,
        file_type: format
      }

      const params = proovCodes
        ? { proov_code: proovCodes, email: !download, url: download  }
        : { email: !download, url: download }
      return await this.request(token, 'post', 'report/export', params, query)
    } catch (error) {
      throw new Error(error)
    }
  }

  async updateReportParts(token, proovCode, fields) {
    try {
      return await this.request(token, 'post', `report/${proovCode}`, { fields }, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
